<!-- 
 FILE BROWSER
 -->
<template>
    <div class="file-browser">
        <div class="nav-bar" v-if="nav">
            <btn i="home" s='m'  @press="toHome" />
            <div class="btn-group">
                <btn i="arrow-left" s="m" @press="back"/>
                <btn i="arrow-right" s="m" @press="foward"/>
            </div>
            <!-- <div class="btn-group">
                <btn i="list-ul" s="m" />
                <btn i="th" s="m" />
            </div> -->
            <div class="adr-bar">
                {{path}}
            </div>
        </div>
        <div class="files" :style="{height: height?(height-(nav?41:0))+'px':'auto'}">
            <div class="file" v-for="file in files.filter(f=>f.parent === currentDir )" @click="onClick(file)">
                <div class="left">
                    <span :class="`file-icon fal fa-${extentions[file.ext]?extentions[file.ext].icon:'file'}`"></span>
                </div>
                <span class="right">
					<span class="fal fa-ellipsis-v"></span>
                <!-- <span class="fal fa-star"></span>&nbsp;&nbsp;&nbsp;
					<span class="fal fa-trash"></span>&nbsp;&nbsp;&nbsp;
					<span class="fal fa-download"></span> -->
                </span>
                <div class="mid">
                    <div class="title">{{file.name}}{{file.ext!='dir'?'.'+file.ext:''}}</div>
                    <div class="date">{{file.created}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import fileExts from "../../assets/json/file-extentions.json";
export default {
    name: 'file-browser',
    props: {
        showRoot: { type: Boolean, default: !false },
        nav: { type: Boolean, default: !false },
        height: { type: Number, default: 0 }
    },
    methods: {
        onClick(file) {
            if (file.ext === 'dir') {
                this.currentDir = file._id;
            }
        },
        toHome() {
            this.currentDir = ""
        },
        foward() {
            if (!this.currentDir) return;
            this.currentDir = this.fileTree[this.currentDir].parent;
        },
        back() {
            if (!this.currentDir) return;
            this.history = [this.currentDir];
            this.currentDir = this.fileTree[this.currentDir].parent;
        }
    },
    computed: {
        fileTree() {
            let _items = this.files.reduce((ns, item) => {
                item.childs = 0;
                ns[item._id] = item;
                return ns;
            }, {});

            Object.keys(_items).map((itemId) => {
                if (!_items[_items[itemId].parent]) return;
                _items[_items[itemId].parent].childs++;
            });
            console.log(_items)
            return _items;
        }
    },
    data() {
        return {
        	history:[],
            path: "/",
            currentDir: "",
            files: [{
                name: "Привет Андрей",
                ext: "dir",
                _id: "1",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: ""
            }, {
                name: "Привет Андрей",
                ext: "mp3",
                _id: "2",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "1"
            }, {
                name: "Здраствуй Андрей",
                ext: "jpg",
                _id: "3",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "1"
            }, {
                name: "Здраствуй Андрей",
                ext: "iso",
                _id: "4",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "1"
            }, {
                name: "Здраствуй Андрей",
                ext: "pdf",
                _id: "5",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "1"
            }, {
                name: "A Андрей",
                ext: "dir",
                _id: "6",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: ""
            }, {
                name: "Здраствуй Андрей",
                ext: "pdf",
                _id: "7",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "6"
            }, {
                name: "Здраствуй Андрей",
                ext: "pdf",
                _id: "8",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "6"
            }, {
                name: "Здраствуй Андрей",
                ext: "pdf",
                _id: "9",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "6"
            }, {
                name: "Здраствуй Андрей",
                ext: "pdf",
                _id: "10",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "6"
            }, {
                name: "Здраствуй Андрей",
                ext: "pdf",
                _id: "11",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "1"
            }, {
                name: "Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей Привет Андрей ",
                ext: "docx",
                _id: "12",
                created: "Добавлен 7 дней назад",
                owner: "",
                parent: "6"
            }],
            extentions: fileExts
        }
    }
}
</script>
<style lang="css" scoped>
.file-browser {
    border: 1px solid lightgrey;
    border-radius: 4px;
    margin: 4px;

}

.adr-bar {
    border: 1px solid lightgrey;
    display: inline-block;
    padding: 5px 4px;
    margin: 4px;
    border-radius: 2px;
    background-color: white;
    width: calc( 100% - 122px ); 
}

.nav-bar {
    padding: 0 4px;
    border-bottom: 1px solid lightgrey;
    background-color: whitesmoke;
}

.file-icon {
    font-size: 38px;
}

.files {
    overflow-y: scroll;
}

.file {
    border-bottom: 1px solid lightgrey;
    overflow: hidden;
    padding: 12px 0;
    cursor: pointer;
    transition: 0.3s all ease;
}

.file:hover {
    background: whitesmoke;
}

.file .left {
    float: left;
    width: 52px;
    margin-right: 4px;
    text-align: center;
}

.file .mid {}

.file .right {
    float: right;
    height: 42px;
    width: 42px;
    height: 100%;
    vertical-align: middle;
    font-size: 32px;
    text-align: center;
}

.file .title {
    font-size: 18px;
    white-space: nowrap;
    max-width: calc(100% - 80px);
    overflow: hidden;
    padding-top: 2px;
}

.file .date {
    font-size: 12px;
}
</style>